import { render, staticRenderFns } from "./TestDrag.vue?vue&type=template&id=bed14efe&scoped=true&"
import script from "./TestDrag.vue?vue&type=script&lang=js&"
export * from "./TestDrag.vue?vue&type=script&lang=js&"
import style0 from "./TestDrag.vue?vue&type=style&index=0&id=bed14efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed14efe",
  null
  
)

export default component.exports